/**
 * 子パターンフィルタ（#2967）。
 *
 * 要注意フィルタ（#3262・needsReviewFilter）と同じく、Firestore の複合インデックスを
 * 増やさないためクライアントサイドで絞り込む。
 * 2つの絞り込みで方式が分かれると保守が分かれるため、意図的に揃えている。
 */

import type { DocumentData } from 'firebase/firestore';
import { SUB_PATTERN_ID_BASE } from '../../constants/enum';

/**
 * 子パターンで絞り込む（#2967）。
 *
 * @param results 絞り込み対象
 * @param subPatternId 子パターンID / SUB_PATTERN_ID_BASE（標準のみ）。未指定・空なら素通し
 */
export const filterBySubPattern = <T extends DocumentData>(
  results: T[],
  subPatternId?: string | null,
): T[] => {
  if (!subPatternId) return results;

  // 標準（子パターンを適用していない）を選んだ場合。
  // 本機能リリース前のデータは sub_pattern_id 自体を持たないが、
  // 子パターンを使わずに読み取られたものなので標準として扱う
  if (subPatternId === SUB_PATTERN_ID_BASE) {
    return results.filter(result => !result.sub_pattern_id);
  }

  return results.filter(result => result.sub_pattern_id === subPatternId);
};
